export default __webpack_public_path__ + "static/TTCommons-Light-4bec6c7e7b04e0c7152fa898c10dfd36.woff2";